<template>
  <div class="callback">
    <DebuggerConfig class="callback-config" />
    <DebuggerOutput />
  </div>
</template>

<script setup lang="ts">
import DebuggerConfig from '@/components/DebuggerConfig.vue';
import DebuggerOutput from '@/components/DebuggerOutput.vue';
</script>

<style scoped>
.callback {
  display: flex;
  align-items: flex-start;
}

.callback-config {
  position: sticky;
  top: 0;
}
</style>
